import React from 'react';
import {View} from 'react-native';

import Text from '/component/base/Text';
import {getCandidateSource} from '/component/partial/report/DateAddedComponent/DateAddedComponent.util';
import {DownlineProfile} from '/constant/TestIDs';
import {getDateUtilDefaultInstance} from '/util/date.util';
import testProperties from '/util/testing/testProperties';

import {styles} from './ProfileHeader.style';
import {ProfileHeaderProps} from './ProfileHeader.types';

export const ProfileHeader = ({
  name = '',
  source = '',
  createdOn = '',
}: ProfileHeaderProps) => {
  const displaySource = getCandidateSource(source)?.name || 'Leads Pool';
  return (
    <View style={styles.base}>
      <View style={styles.infoColumn}>
        <Text
          variant="large"
          {...testProperties(DownlineProfile.candidateName)}>
          {name}
        </Text>
        <View style={styles.optaviaTextContainer}>
          <Text
            style={styles.dateText}
            {...testProperties(DownlineProfile.candidateSource)}>
            Added from {displaySource} on{' '}
            {getDateUtilDefaultInstance().formatDate(createdOn, 'MMMM d, yyyy')}
          </Text>
        </View>
      </View>
    </View>
  );
};

export default ProfileHeader;
